import React from 'react'
import { useQuery } from 'react-query'
import { descend, indexBy, pathOr, prop, sort } from 'ramda'
import { IOtherCategory } from './options.type'

// TYPE0	不分類	TYPE1	上游 TYPE2	下游
export const useOthersCategories = () => {
  const { data, isLoading, refetch } = useQuery<IOtherCategory[]>(
    ['/options/othersCategories'],
    {
      select: data => {
        return sort(descend(prop('orderSeq')), pathOr([], ['data'], data))
      },
    }
  )

  const byId = React.useMemo(() => {
    return indexBy(prop('id'), data || [])
  }, [data])

  return { data, isLoading, refetch, byId }
}
